import React from 'react';
import { popupOpenService } from '../../../services/popupOpenService';
import { POPUP_KEY_CREATE_PROPERTY } from '../../../constant';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const CreateNewPropertyButton = () => {
    const { i18n } = useTranslation();
    const openPopup = () => {
        popupOpenService.callToOpen(POPUP_KEY_CREATE_PROPERTY, null);
    };

    return (
        <Button variant="outline" className="product__button" onClick={openPopup}>
            {i18n.t('app.page.product.addProperty')}
        </Button>
    );
};

export default CreateNewPropertyButton;
